import { connect } from 'react-redux';
import ScribeSearchInput from './ScribeSearchInput';
import { getSearchMatches } from '../../selectors/index';
import {
  scribeExitSearchMode,
  scribeUpdateSearchQuery,
  scribePreviousSearchMatch,
  scribeNextSearchMatch,
  scribeSelectTranscriptWord,
} from '../../actions';

const mapStateToProps = state => {
  const {
    scribeTranscriptUI: { searchModeEnabled, searchQuery },
    scribeConversation: {
      ui: { selectedSearchMatchIndex },
    },
  } = state;

  return {
    searchModeEnabled,
    searchQuery,
    searchMatches: getSearchMatches(state),
    selectedSearchMatchIndex,
  };
};

export default connect(
  mapStateToProps,
  {
    scribeExitSearchMode,
    scribeUpdateSearchQuery,
    scribePreviousSearchMatch,
    scribeNextSearchMatch,
    scribeSelectTranscriptWord,
  }
)(ScribeSearchInput);
